const initialState = {
  cartItems: [],
  loading: false,
  error: null,
  updating: false,
};

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_TO_CART_REQUEST":
    case "FETCH_CART_REQUEST":
      return { ...state, loading: true, error: null };

    case "ADD_TO_CART_SUCCESS":
      // console.log("🔁 cartReducer ADD_TO_CART_SUCCESS:", action.payload);
      return {
        ...state,
        loading: false,
        cartItems: action.payload, // replace entire cart with updated data from backend
        error: null,
      };

    case "FETCH_CART_SUCCESS":
      // console.log("🔁 cartReducer FETCH_CART_SUCCESS:", action.payload);
      return {
        ...state,
        loading: false,
        cartItems: action.payload, // replace with fetched cart data
        error: null,
      };

    case "ADD_TO_CART_FAILURE":
    case "FETCH_CART_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_CART_REQUEST":
      return { ...state, updating: true, error: null };

    case "UPDATE_CART_SUCCESS": {
      const updated = action.payload;
      return {
        ...state,
        updating: false,
        cartItems: state.cartItems.map((item) =>
          item.cart_id === updated.cart_id ? { ...item, ...updated } : item
        ),
      };
    }

    case "UPDATE_CART_FAILURE":
      return { ...state, updating: false, error: action.payload };

    case "DELETE_CART_REQUEST":
      return { ...state, updating: true, error: null };

    case "DELETE_CART_SUCCESS":
      return {
        ...state,
        loading: false,
        cartItems: state.cartItems.filter(
          (item) => item.cart_id !== action.payload
        ),
      };

    case "DELETE_CART_FAILURE":
      return { ...state, updating: false, error: action.payload };

    // case "CLEAR_CART":
    //   return {
    //     ...state,
    //     cartItems: [],
    //   };

    default:
      return state;
  }
};
